<template>
  <v-card>
    <!--Indicators-->
    <v-layout>
      <v-list class="blue lighten-3" dark>
        <h2 class="text-lg-center text-padding">Basin {{ id }} Indicators</h2>
        <v-list-tile
                v-for="(item, index) in Object.keys(basinData)"
                :key="index"
                @click="selectIndicator(item)"
                :class="getColor(item)">
          <v-list-tile-action>
            <v-icon v-if="activeIndicators.includes(item)">remove_circle_outline</v-icon>
            <v-icon v-else>add_circle_outline</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <!--Chart-->
      <div v-if="activeIndicators.length > 0" class="card-fill">
        <v-card dark>
          <h2 class="chart-title">Index</h2>
          <chartist
                  type="Bar"
                  :data="chartData"
                  :options="chartOptions"
                  class="chart-center">
          </chartist>
          <h2 class="chart-footer">Scenario</h2>
        </v-card>
      </div>

      <!--close button-->
      <v-btn @click="close" flat class="close-button">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "basin",

    props: {
      id: {
        type: Number,
        required: true
      },
      watershed: {
        type: String,
        required: true
      },
      allBasinData: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        activeIndicators: [],
        chartOptions: {
          high: 1,
          low: 0
        },
        graphColors: [
          'chart-cyan',
          'chart-red',
          'chart-orange',
          'chart-purple',
          'chart-green',
          'chart-gray',
          'chart-blue',
          'chart-behance'
        ]
      }
    },

    methods: {
      close () {
        this.$emit('close-basin-data')
      },
      selectIndicator (name) {
        Object.keys(this.basinData).forEach(key => {
          if (key === name) {
            if (this.activeIndicators.includes(name)) {
              this.activeIndicators = this.activeIndicators.filter(val => {
                return val !== name
              });
            } else {
              this.activeIndicators.push(name)
            }
          }
        })
      },
      getColor (name) {
        if (this.activeIndicators.includes(name)) {
          let color = null;
          let i = 0;
          this.activeIndicators.forEach(indicator => {
            if (indicator === name) {
              color = this.graphColors[i]
            }
            i++
          });
          return color
        } else {
          return null
        }
      }
    },

    computed: {
      basinData () {
        let basinData = this.allBasinData.filter(b => { return b.name === this.watershed });
        if (basinData.length > 0) {
          return basinData[0].data[this.id] || {}
        } else {
          return {}
        }
      },
      chartData () {
        let allSeries = [];
        let labels;
        this.activeIndicators.forEach(indicator => {
          let data = this.basinData[indicator];
          labels = Object.keys(data);
          let series = [];

          Object.values(data).forEach(val => {
            series.push({
              value: Math.round(val * 1000) / 1000
            })
          });
          allSeries.push(series)
        });

        return {
          labels: labels,
          series: allSeries
        }
      }
    },

    watch: {
      id () {
        this.activeIndicators = []
      }
    }
  }
</script>

<style scoped>
  .text-padding {
    padding: 5px;
  }
  .close-button {
    position: absolute;
    top: 0;
    right: 0;
  }
  .card-fill {
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    height: 400px;
  }
  .chart-center {
    max-height: 300px;
  }
  .chart-title {
    padding: 10px;
  }
  .chart-footer {
    padding: 10px;
    text-align: center;
  }
</style>
